import classnames from 'classnames';
import { Col, Button, Input, Row } from 'reactstrap';
import React, { ChangeEvent } from 'react';
import { XIcon } from '@primer/octicons-react';

import ApprovedTimesheetDetails from 'features/pending-timesheets/components/approved-timesheet-details.component';
import { IOnlineApprovalTimeEntry } from 'features/pending-timesheets/models/online-approval-time-entry.model';

import { ITimesheetEditModalState } from './timesheet-edit-modal.component';
import TimesheetEditEntry from './timesheet-edit-entry.component';

import 'features/pending-timesheets/styles/timesheet-edit-modal.mobile.scss';
import TimesheetComment from '../timesheet-comment.component';
import { ReactComponent as PlusIcon } from 'images/plus.svg';
import classNames from 'classnames';

const renderMobile = (props: ITimesheetEditModalState): JSX.Element => {
    const { supervisorComments, selectedTimesheet, isSaveDisabled, showCommentError } = props;

    const renderFooter = (): JSX.Element => {
        return (
            <>
                <TimesheetComment timesheetComment={selectedTimesheet?.timesheetComment} textAlign={'text-center'} />
                <span className={'mobile-only'}>
                    <ApprovedTimesheetDetails
                        approvedDate={selectedTimesheet?.onlineApprovalDate}
                        supervisorComments={supervisorComments}
                        textAlign={'text-center'}
                    />
                </span>

                <Row className="w-100">
                    <Col>
                        <Row className="font-weight-bold mb-2">
                            <Col xs={13}>Total Hours</Col>
                            <Col>{selectedTimesheet?.totalHours?.toFixed(2)}</Col>
                        </Row>
                        {selectedTimesheet && selectedTimesheet.regularHours > 0 && (
                            <Row className="font-weight-bold mb-2">
                                <Col xs={13}>Regular</Col>
                                <Col>{selectedTimesheet?.regularHours?.toFixed(2)}</Col>
                            </Row>
                        )}
                        {selectedTimesheet && selectedTimesheet.onCallHours > 0 && (
                            <Row className="font-weight-bold mb-2">
                                <Col xs={13}>On Call</Col>

                                <Col>{selectedTimesheet?.onCallHours?.toFixed(2)}</Col>
                            </Row>
                        )}
                        {selectedTimesheet && selectedTimesheet.callbackHours > 0 && (
                            <Row className="font-weight-bold mb-2">
                                <Col xs={13}>Callback: </Col>
                                <Col>{selectedTimesheet?.callbackHours?.toFixed(2)}</Col>
                            </Row>
                        )}
                        {selectedTimesheet && selectedTimesheet.chargeHours > 0 && (
                            <Row className="font-weight-bold mb-2">
                                <Col xs={13}>Charge: </Col>
                                <Col>{selectedTimesheet?.chargeHours?.toFixed(2)}</Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                <Row className={'save-close-row modal-footer'}>
                    <Col>
                        {!selectedTimesheet.onlineApprovalDate && (
                            <>
                                <Button
                                    id="save-button"
                                    color={isSaveDisabled ? 'light' : 'primary'}
                                    className={classnames(['rounded-pill', { 'text-muted': isSaveDisabled }])}
                                    onClick={() => {
                                        props.save(selectedTimesheet, supervisorComments);
                                    }}
                                    disabled={isSaveDisabled}
                                >
                                    Save & Close
                                </Button>
                            </>
                        )}
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <div className={'timesheet-edit-modal-mobile'}>
            <div
                className={classnames([
                    'slideout',
                    'theme-green',
                    {
                        active: props.isOpen,
                    },
                ])}
            >
                <div className="modal-header d-flex justify-content-between">
                    <div>
                        {selectedTimesheet?.travelerFirstName} {selectedTimesheet?.travelerLastName}
                    </div>
                    <Button color="link" className={'close-button'} onClick={props.close}>
                        <XIcon size={16} />
                    </Button>
                </div>

                <div className={'modal-body'}>
                    {props.isLoading ? (
                        <p>Loading...</p>
                    ) : (
                        props.selectedTimesheetTimeEntries
                            ?.filter(
                                (te: IOnlineApprovalTimeEntry) => te.timesheetId === selectedTimesheet?.timesheetId,
                            )
                            .map((timeEntry: IOnlineApprovalTimeEntry, i: number) => (
                                <TimesheetEditEntry
                                    key={timeEntry.id + i}
                                    entryKey={timeEntry.id + i}
                                    timeEntry={timeEntry}
                                    timesheetPackage={props.timesheetPackage}
                                />
                            ))
                    )}

                    {props.showAddDelete && (
                        <Button color="light" block className="rounded-pill mt-3" onClick={props.addShift}>
                            <PlusIcon />
                            &nbsp; Add Shift
                        </Button>
                    )}

                    {!selectedTimesheet.onlineApprovalDate && (
                        <>
                            <label htmlFor="supervisorComments" className="sr-only large-text">
                                Supervisor Comments (required)
                            </label>
                            <Input
                                className={classNames([
                                    'timeentry-comment',
                                    {
                                        'error-highlight': showCommentError,
                                    },
                                ])}
                                disabled={!!selectedTimesheet.onlineApprovalDate}
                                type="textarea"
                                name="supervisorComments"
                                id="supervisorComments"
                                placeholder="comment required to edit timesheet"
                                value={supervisorComments}
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                    props.setSupervisorComments(e?.target?.value)
                                }
                            />
                        </>
                    )}

                    {renderFooter()}
                </div>
            </div>
        </div>
    );
};

export default renderMobile;
